import { all, call, fork, takeLatest } from 'redux-saga/effects';

import * as constants from './personal-notes.constants';
import * as types from './personal-notes.types';
import * as services from './personal-notes.saga-services';

function* invokeSetupPersonalNotes() {
  yield call(services.setupPersonalNotes);
}

function* invokeCreatePersonalNote() {
  yield call(services.createPersonalNote);
}

function* invokeUpdatePersonalNote(action: types.IUpdatePersonalNote) {
  yield call(services.updatePersonalNote, action.payload.id, action.payload.data);
}

function* invokeDeletePersonalNote(action: types.IDeletePersonalNote) {
  yield call(services.deletePersonalNote, action.payload);
}

export function* watchPersonalNotesPurePageSaga() {
  yield takeLatest(constants.SETUP_PERSONAL_NOTES, invokeSetupPersonalNotes);
  yield takeLatest(constants.CREATE_PERSONAL_NOTE, invokeCreatePersonalNote);
  yield takeLatest(constants.UPDATE_PERSONAL_NOTE, invokeUpdatePersonalNote);
  yield takeLatest(constants.DELETE_PERSONAL_NOTE, invokeDeletePersonalNote);
}

export function* watchPersonalNotesPageStorageSaga() {
  yield all([watchPersonalNotesPurePageSaga].map(fork));
}
